// extracted by mini-css-extract-plugin
module.exports =  {"legacyScroll":"C_MOyoio0tezLFREdqlR","deleteButton":"Yk8OXR6jEUMoD_QdjYPN","leftActions":"NpfO2kffl1KXG06xk3gn","lastPublished":"_zqj6HXH3BnH8a5DzXlo"};